export default __webpack_public_path__ + "assets/images/04855cc568fa727a5055fde4b5e73a4e.png";